// API Configuration - Based on ProjectUrls from Flutter app
// Dynamically determine backend base URL from current web URL (hostname)
const getBackendBaseUrl = () => {
  try {
    // Explicit local backend for isolated builds; deployment hostname defaults stay unchanged.
    if (process.env.REACT_APP_API_BASE_URL) return process.env.REACT_APP_API_BASE_URL;

    const hostname = typeof window !== 'undefined' && window.location ? window.location.hostname : '';
    // Production: jobs.channelplay.in
    if (hostname === 'jobs.channelplay.in') {
      return 'https://endpoints-backend.api.1office.channelplay.in/';
    }
    // Preprod: preprod.jobs.channelplay.in
    if (hostname === 'preprod.jobs.channelplay.in') {
      return 'https://endpoints-backend.api.preprod.1office.channelplay.in/';
    }
    // QA or Localhost: qa.jobs.channelplay.in, localhost, 127.0.0.1
    if (hostname === 'qa.jobs.channelplay.in' || hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'https://endpoints-backend.api.preprod.1office.channelplay.in/';
    }
    // Fallback: default to Production
    return 'https://endpoints-backend.api.1office.channelplay.in/';
  } catch (e) {
    // In any unexpected scenario, use Production as a safe default
    return 'https://endpoints-backend.api.1office.channelplay.in/';
  }
};


const DYNAMIC_BASE_URL = getBackendBaseUrl();

export const API_CONFIG = {
  // Base URLs
  baseUrl: DYNAMIC_BASE_URL,
  loginMicroservicePath: 'corporate-recruitment/',
  legacyMicroservicePath: 'legacy-services/',
  candidateMicroservicePath: 'candidate-services/',
  
  // Service URLs for authentication
  AUTH_SERVICE: `${DYNAMIC_BASE_URL}corporate-recruitment/channelplayJobs`,
  USER_SERVICE: `${DYNAMIC_BASE_URL}corporate-recruitment/channelplayJobs`,
  
  // Google Maps API
  googleApiKey: 'AIzaSyBDWTT-7isHcQo49RANzBpu1juj0HPI5vw',

  // SSI Widget Configuration
  ssiSupabaseUrl: 'https://sysbbjgvjxdqprzrzwfs.supabase.co',
  ssiSupabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN5c2Jiamd2anhkcXByenJ6d2ZzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjczNDEwMTUsImV4cCI6MjA4MjkxNzAxNX0.-EDx2keKz0u6PRfX5nvUlvra6zbj2OVfDjO4fX8_MDY',

  // Timeout configurations
  defaultTimeout: 30000,
  shortTimeout: 10000,
  longTimeout: 60000,
};

// API Endpoints
export const API_ENDPOINTS = {
  // OTP Authentication endpoints
  generateOtp: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/generateOTP`,
  validateOtp: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/validateOTP`,

  // Job endpoints - Unified search endpoint
  searchJobs: `${API_CONFIG.baseUrl}recruiter-services/api/v1/positions/searchJobs`,
  fetchJobById: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/getJobById`,
  // Legacy endpoints (deprecated - use searchJobs instead)
  fetchJobsByCoordinates: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchJobsByCoordinatesWithPagination`,
  fetchJobsWithFilters: `${API_CONFIG.baseUrl}recruiter-services/api/v1/positions/fetchJobsWithFilters`,
  applyForJob: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/applyForJob`,
  updateWhatsAppEngagementForJobsApp: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/updateWhatsAppEngagementForJobsApp`,
  fetchPlaceIdDetails: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchPlaceIdDetails`,
  getLocationResults: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/getLocationResults`,
  geocodeAddress: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/geocode`,
  saveCandidateLocation: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/saveCandidateLocationIfNotApplied`,
  
  // Referral endpoints
  fetchReferrals: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchReferrals`,
  createReferral: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/referCandidates`,
  
  // Earnings endpoints
  fetchEarnings: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/myEarnings`,
  updateReferralStatus: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/referrals/status/update`,
  requestPayment: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/earnings/payment/request`,
  directTransfer: `${API_CONFIG.baseUrl}${API_CONFIG.legacyMicroservicePath}api/v1/cashfree/directTransfer`,
  
  // User Profile Management
  updateUserProfile: `${API_CONFIG.baseUrl}${API_CONFIG.candidateMicroservicePath}api/v1/candidate/`, // Will append candidateId for PUT method
  updateProfileJsonOnly: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/updateProfileJsonOnly`,
  updateCandidateResume: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/updateCandidateResume`,
  getCandidateDetailsByMobile: `${API_CONFIG.baseUrl}${API_CONFIG.candidateMicroservicePath}api/v1/candidate/getDetailsWithMob/`,
  userToken: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}api/auth/fetchProgrammaticUserToken`,
  
  // Applications endpoints
  fetchApplications: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchApplications`,
  updateApplicationStatus: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/updateApplicationStatus`,
  scheduleInterview: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/scheduleInterview`,
  fetchCandidateApplications: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchCandidateApplications`,
  fetchCandidateTimeline: `${API_CONFIG.baseUrl}recruiter-services/api/v1/positions/candidate-timeline/`,
  lastAppliedJobs: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/lastAppliedJobs`,
  
  // Interview endpoints
  fetchClientInterviews: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchClientInterviews`,
  fetchInterviewFeedback: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchInterviewFeedback`,
  updateInterviewFeedback: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/updateInterviewFeedback`,
  
  // KYC verification endpoints
  fetchCandidateKYCDetails: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchCandidateKYCDetails`,
  sendAadhaarOTP: `${API_CONFIG.baseUrl}${API_CONFIG.legacyMicroservicePath}api/v1/cashfree/getAadhaarOTP/`,
  verifyCandidateAadhaar: `${API_CONFIG.baseUrl}${API_CONFIG.legacyMicroservicePath}api/v1/cashfree/verifyCandidateAadhaar`,
  verifyCandidatePAN: `${API_CONFIG.baseUrl}${API_CONFIG.legacyMicroservicePath}api/v1/candidate/verifyCandidatePAN`,
  // Aadhaar verification by file upload (candidate endpoint)
  verifyCandidateAadhaarByFile: `${API_CONFIG.baseUrl}${API_CONFIG.legacyMicroservicePath}api/v1/candidate/verifyCandidateAadhaar`,
  updateKycStatus: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/updateKycStatus`,
  verifyAadhaarCard: `${API_CONFIG.baseUrl}${API_CONFIG.legacyMicroservicePath}api/v1/myDocument/verifyAadhaarCard`,
  updateCandidateAadhaarDetails: `${API_CONFIG.baseUrl}${API_CONFIG.legacyMicroservicePath}api/v1/cashfree/updateCandidateAadhaarDetailsForChannelplayJobs`,
  
  // Location endpoints
  fetchCurrentLocation: `https://maps.googleapis.com/maps/api/geocode/json?key=${API_CONFIG.googleApiKey}&latlng=`,
  fetchCurrentLatLng: `https://www.googleapis.com/geolocation/v1/geolocate?key=${API_CONFIG.googleApiKey}`,
  
  // Skills endpoints
  fetchCandidateSkills: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchCandidateSkills`,
  fetchInactiveCandidateSkills: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchInactiveCandidateSkills`,
  fetchInactiveCandidateSkillsWithoutFallback: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchInactiveCandidateSkillsWithoutFallback`,
  fetchRecommendedSkillsForCandidate: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchRecommendedSkillsForCandidate`,
  saveCandidateSkills: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/saveCandidateSkills`,
  fetchAllActiveSkills: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchAllActiveSkills`,
  fetchActiveSkillsInSortedOrder: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchActiveSkillsInSortedOrder`,
  markCandidateSkillsAsRemoved: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/markCandidateSkillsAsRemoved`,
  
  // Jobs filter options endpoint
  getJobsFilterOptions: `${API_CONFIG.baseUrl}recruiter-services/api/v1/positions/getJobsFilter`,
  
  // Language endpoints
  fetchMultilingualText: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchMultiLingualText`,
  convertInputToMultilingual: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/covertInputToMultiLingualText`,
  fetchAppLanguage: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/fetchAppLanguage`,
  
  // URL shortening
  getActualUrl: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}api/auth/getActualUrl`,

  // Notification endpoints
  fetchNotifications: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/getNotificationsLast7Days`,
  markNotificationAsRead: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/markNotificationReadStatus`,
  setNotificationEngagementFlag: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/setNotificationEngagementFlag`,
  getTotalUnreadNotificationCount: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/getTotalCountOfUnreadNotification`,

  // Candidate profile endpoints
  getCandidateByMobile: `${API_CONFIG.baseUrl}${API_CONFIG.candidateMicroservicePath}api/v1/candidate/getDetailsWithMob/`,
  addUpdateCandidate: `${API_CONFIG.baseUrl}${API_CONFIG.candidateMicroservicePath}api/v1/candidate/addUpdateCandidate`,
  updateCandidate: `${API_CONFIG.baseUrl}${API_CONFIG.candidateMicroservicePath}api/v1/candidate/`,
  createCandidate: `${API_CONFIG.baseUrl}${API_CONFIG.candidateMicroservicePath}api/v1/candidate`,
  
  // Download resume URL
  downloadResume: `${API_CONFIG.baseUrl}${API_CONFIG.legacyMicroservicePath}api/v1/user/downloadFileFromAWS`,

  // Budget endpoints
  fetchBudgetDetailsById: `${API_CONFIG.baseUrl}${API_CONFIG.legacyMicroservicePath}api/v1/budget/fetchBudgetDetailsById`,

  // Device token endpoint
  saveUpdateDeviceToken: `${API_CONFIG.baseUrl}${API_CONFIG.loginMicroservicePath}channelplayJobs/saveUpdateDeviceToken`,

  // Deep link job details endpoint
  getJobDetailsByBudgetCityId: `${API_CONFIG.baseUrl}recruiter-services/api/v1/positions/getJobDetailsByBudgetCityId`,
};
